import type { ReactNode } from 'react';
import React from 'react';
import * as S from './styles';

interface Props {
  children: ReactNode;
  collapsed?: boolean;
  expandText: string;
  onExpand: () => void;
  className?: string;
}

export const Collapsible = ({
  children,
  collapsed,
  expandText,
  onExpand,
  className,
}: Props) => (
  <S.CollapsibleWrapper collapsed={collapsed} className={className}>
    {children}
    {collapsed && (
      <S.ExpandButton onClick={onExpand}>{expandText}</S.ExpandButton>
    )}
  </S.CollapsibleWrapper>
);
